import { styled, TextField } from "@mui/material";

const CustomTextField = styled((props) => {
  const { InputProps, ...other } = props;
  return (
    <TextField
      variant="filled"
      slotProps={{
        input: {
          ...InputProps,
        },
      }}
      {...other}
    />
  );
})(({ theme }) => ({
  "& .MuiInputLabel-root": {
    paddingLeft: "12px",
    transition: theme.transitions.create(["padding-left", "transform"], {
      duration: theme.transitions.duration.shorter,
    }),
  },
  "& .MuiInputLabel-shrink": {
    paddingLeft: "14px",
  },
  "& .MuiFilledInput-root": {
    // These lines remove the bottom border entirely
    "&:before, &:after": {
      display: "none",
    },
    "&:hover:not(.Mui-disabled):before": {
      display: "none",
    },
    overflow: "hidden",
    borderRadius: "var(--borderRadius)",
    backgroundColor: "var(--inputBackground)",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    "& .MuiFilledInput-input": {
      fontSize:"var(--subtextSize)",
      paddingLeft: "25px",
      "&.MuiInputBase-inputMultiline": {
        paddingLeft: "11px",
      },
      "&:-webkit-autofill": {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      },
      "&::-ms-reveal, &::-ms-clear": {
        display: "none",
      },
    },
    "&:hover": {
      filter: "brightness(0.95)",
    },
    "&.Mui-focused": {
      borderColor: "var(--text)",
    },
  },
}));

export default CustomTextField;
